import React, { useEffect, useRef } from "react";
import { Button, Form, Modal, ModalFooter } from "react-bootstrap";
import { useData } from "../storage/accessors";

type Props = {
    popup: boolean;
    toggle: () => void;
};

export default function WheelPropsModal({ popup, toggle }: Props) {
    const { wheels } = useData()
    const wheel = wheels.objects['wheel'];
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (popup) {
            setTimeout(() => {
                if (ref.current) {
                    ref.current.focus();
                    ref.current.select();
                }
            }, 100);
        }
    }, [popup]);

    const saveOnEnter = (e: any) => {
        if (e.key === "Enter") {
            toggle();
        }
    };

    return (
        <Modal show={popup} onHide={wheel?.name ? toggle : undefined}>
            <Modal.Header>Настроить хранилище</Modal.Header>
            <Modal.Body>
                <Form onSubmit={toggle} onKeyUp={saveOnEnter}>
                    <Form.Group>
                        <Form.Label>Название</Form.Label>
                        <Form.Control type="text" value={wheel?.name} onChange={(e: any) => wheels.save('wheel', { name: e.target.value })} ref={ref} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Период</Form.Label>
                        <Form.Control type="text" value={wheel?.dateDescription} onChange={(e: any) => wheels.save('wheel', { dateDescription: e.target.value })} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <ModalFooter>
                <Button variant="outline-primary" disabled={!wheel?.name} onClick={toggle}>
                    Сохранить
                </Button>
            </ModalFooter>
        </Modal>
    );
}
